// extracted by mini-css-extract-plugin
module.exports = {"Green":"InfoPasswordLabels_Green__3XG30","Red":"InfoPasswordLabels_Red__2PMes"};